import {
  ActualVsPlannedPage,
  performanceReportsFeatureTranslations,
  type ActualVsPlannedRoutes
} from '@features/performance-reports'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {AxiosError} from 'axios'
import React, {useCallback, useEffect, useMemo} from 'react'
import {generatePath, useNavigate, useParams} from 'react-router'

import {handleError} from '../../shared/helpers'
import {useNavAccessContext} from '../../shared/hooks/useNavAccessContext'
import {
  AREA_KPI,
  GLOBAL_KILN_PERFORMANCE,
  LOCATION_KPI,
  LOCATION_KPI_STATUS,
  PLANT_PERFORMANCE
} from '../routing'

export const PerformanceStatusWrapper: React.FC = () => {
  const navigate = useNavigate()
  const {locationId} = useParams<{locationId?: string}>()
  const {allowMultipleLocations, allowMultiplePlants, getRedirectURL, isLocationAllowed} =
    useNavAccessContext()

  useEffect(() => {
    if (!allowMultipleLocations()) {
      const redirectURL = getRedirectURL()

      if (redirectURL) {
        void navigate(redirectURL)
      }
    }
  }, [allowMultipleLocations, getRedirectURL, navigate])

  const routes = useMemo<ActualVsPlannedRoutes>(
    () => ({
      global: GLOBAL_KILN_PERFORMANCE,
      area: (id) => generatePath(AREA_KPI, {locationId: id}),
      location: (id) => generatePath(LOCATION_KPI, {locationId: id}),
      plant: (plantId) => generatePath(PLANT_PERFORMANCE, {plantId}),
      countryHeader: (id) =>
        isLocationAllowed(id) ? generatePath(LOCATION_KPI_STATUS, {locationId: id}) : undefined
    }),
    [isLocationAllowed]
  )

  const onError = useCallback((error: AxiosError) => handleError(error, navigate), [navigate])

  return (
    <FeatureTranslationsLoader translations={performanceReportsFeatureTranslations}>
      <ActualVsPlannedPage
        locationId={locationId}
        routes={routes}
        showBackToGlobal={allowMultiplePlants()}
        onError={onError}
        inverted
      />
    </FeatureTranslationsLoader>
  )
}
